import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { LetterReadTableService, ReadAnswerInfo, ReadTableRowData } from '@schoolbelle/api/letter-read';
import { minBy } from 'lodash-es';

const STATUS_IN_PRIORITY_ORDER = [
  'answered', 'read', 'not_read', 'not_joined', 'not_registered',
];

@Component({
  selector: 'app-read-list-table',
  templateUrl: './read-list-table.component.html',
  styleUrls: ['./read-list-table.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class ReadListTableComponent implements OnInit {
  @Input() rows:ReadTableRowData[] = []
  @Input() showDetails:boolean = false;
  @Input() query:string;
  constructor(
    public letterRead: LetterReadTableService,
  ) {
    
  }

  ngOnInit () {
  }


  getReadStatus(params:ReadAnswerInfo, args?: string): any {
    if (!params) return null;
    if (params.answered !== 0) {
        return 'answered';
    } else if (params.read !== 0) {
        return 'read';
    } else if (params.joined !== 0) {
        return 'not_read';
    } else if (params.registered !== 0) {
        return 'not_joined';
    }  else {
        return 'not_registered';
    }
  } 
  reduceMultipleReadStatuses (list:ReadAnswerInfo[]):'answered'|'read'|'not_read'|'not_joined'|'not_registered' {
    return minBy(list.filter(li=>li).map(li=>this.getReadStatus(li)), status=>STATUS_IN_PRIORITY_ORDER.indexOf(status));
  }   
}    